import { memo } from 'react';
import { Box } from '../Core';
import { ResultMatchHighlight, ResultMatchHighlightAll } from './styles';
import type { ResultMatchProps } from './types';
import { ResultMatchType } from './types';

export { ResultMatchType } from './types';

export const ResultMatch = memo(
  ({ label, indices = [], highlightAll = false, type = ResultMatchType.Label, disabled = false }: ResultMatchProps) => {
    let matchIndex = 0;
    const result = [''];
    for (let i = 0; i < (label ?? '').length; i++) {
      if (indices[matchIndex] && indices[matchIndex][0] === i) {
        result.push('');
      }
      result[result.length - 1] = result[result.length - 1].concat(label != null ? label[i] : '');
      if (indices[matchIndex] && indices[matchIndex][1] === i) {
        result.push('');
        matchIndex++;
      }
    }

    if (highlightAll && !disabled) {
      return <ResultMatchHighlightAll type={type}>{label}</ResultMatchHighlightAll>;
    }

    return (
      <Box>
        {result.map((part, index) =>
          part !== '' ? (
            index % 2 && !disabled ? (
              <ResultMatchHighlight key={index}>{part}</ResultMatchHighlight>
            ) : (
              <span key={index}>{part}</span>
            )
          ) : null
        )}
      </Box>
    );
  }
);
